interface StaticBarChartProps {
  withFownd: number;
  withoutFownd: number;
}

const StaticBarChart = ({ withFownd, withoutFownd }: StaticBarChartProps) => {
  const maxValue = Math.max(withFownd, withoutFownd);
  const withoutFowndHeight = (withoutFownd / maxValue) * 120;
  const withFowndHeight = (withFownd / maxValue) * 120;

  return (
    <div className="flex flex-col items-center">
      <h4 className="text-lg font-semibold text-slate-700 mb-3">Cost Comparison</h4>
      <div className="relative">
        {/* Y-axis */}
        <div className="absolute left-0 h-40 w-px bg-slate-400" style={{ top: "20px" }}></div>
        
        {/* Y-axis labels */}
        <div className="absolute left-0 text-xs text-slate-500" style={{ top: "20px", transform: "translateX(-100%)" }}>
          ${Math.round(maxValue / 1000)}k
        </div>
        <div className="absolute left-0 text-xs text-slate-500" style={{ top: "80px", transform: "translateX(-100%)" }}>
          ${Math.round(maxValue / 2000)}k
        </div>
        <div className="absolute left-0 text-xs text-slate-500" style={{ top: "140px", transform: "translateX(-100%)" }}>
          $0
        </div>
        
        {/* Chart area */}
        <div className="flex items-end justify-center space-x-6 h-40 ml-8">
          {/* Without Fownd Bar */}
          <div className="flex flex-col items-center">
            <div className="text-sm font-medium text-slate-600 mb-2">
              ${withoutFownd.toLocaleString()}
            </div>
            <div
              className="bg-slate-600 rounded-t-lg flex items-end justify-center relative"
              style={{ width: "50px", height: `${withoutFowndHeight}px` }}
            >
            </div>
            <div className="text-xs font-medium text-slate-700 whitespace-nowrap mt-2">
              Without Fownd
            </div>
          </div>

          {/* With Fownd Bar */}
          <div className="flex flex-col items-center">
            <div className="text-sm font-medium text-slate-600 mb-2">
              ${withFownd.toLocaleString()}
            </div>
            <div
              className="bg-[#1e3d3b] rounded-t-lg flex items-end justify-center relative"
              style={{ width: "50px", height: `${withFowndHeight}px` }}
            >
            </div>
            <div className="text-xs font-medium text-slate-700 whitespace-nowrap mt-2">
              With Fownd
            </div>
          </div>
        </div>
        
        {/* X-axis */}
        <div className="w-full h-px bg-slate-400 ml-8" style={{ marginTop: "2px" }}></div>
        
        {/* X-axis label */}
        <div className="text-center text-xs text-slate-500 mt-2 ml-8">
          Scenario
        </div>
      </div>
      
      {/* Y-axis label */}
      <div className="absolute text-xs text-slate-500 transform -rotate-90" style={{ left: "-20px", top: "50%", transformOrigin: "center" }}>
        Annual Cost
      </div>
      
      <div className="mt-6 text-xs text-slate-500">
        Cost Comparison: Lower is Better
      </div>
    </div>
  );
};

export default StaticBarChart; 